import { createContext } from 'react';
var defaultStaticText = {
  back: "Back",
  filters: "Filters",
  clearFilters: "Clear Filters",
  close: "Close",
  clearAll: "Clear All"
};
var FiltersInternalContext =
/*#__PURE__*/
createContext({
  staticText: defaultStaticText
});
export { FiltersInternalContext, defaultStaticText };